import { fork } from 'redux-saga/effects';

import { createDatasetSaga } from './sagas/createDataset';
import { updateDatasetSaga } from './sagas/updateDataset';
import { fetchDatasetsSaga } from './sagas/fetchDatasets';

export const datasetsSaga = function* () {
  yield fork(createDatasetSaga);
  yield fork(updateDatasetSaga);
  yield fork(fetchDatasetsSaga);
};
